import * as React from 'react';

import HowToGuides32 from './HowToGuides32';

export const howToGuides32 = () => <HowToGuides32 />;

export default {
    title: 'Icon/Logo/HowToGuides32',
    component: HowToGuides32,
    parameters: {
        notes: "`import HowToGuides32 from 'box-ui-elements/es/icon/logo/HowToGuides32';`",
    },
};
